import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import S from '../UI/variables';

export const StyledHeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 120px;
  background-color: #fff;
  & .socials--desktop {
    display: none;
    @media screen and (min-width: ${S.desktop}) {
      display: flex;
    }
  }
  & .socials--mobile {
    display: flex;
    @media screen and (min-width: ${S.desktop}) {
      display: none;
    }
  }
  @media screen and (min-width: ${S.desktop}) {
    position: relative;
  }
`;

export const StyledHeaderLine = styled.div`
  border-bottom: 1px solid ${S.mainBorder};
  width: 100%;
  height: 60px;
`;

export const StyledHeaderNav = styled.nav`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
`;

const StyledHoverIcon = styled.img`
  &:hover {
    filter: brightness(0.5);
  }
  transition: filter ${S.trFast};
`;

export const StyledLogo = styled(StyledHoverIcon)`
  display: inline-block;
  height: 45px;
  width: auto;
`;

export const StyledContactsWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  & > *:not(:last-child) {
    margin-right: 80px;
  }
`;

export const StyledSocialLinks = styled.ul`
  display: flex;
  align-items: center;
  height: 100%;
  & > li:not(:last-child) {
    margin-right: 25px;
  }
`;

export const StyledSocialLink = styled.a`
  display: flex;
  align-items: center;
  height: 33px;
  cursor: pointer;
  color: ${S.mainBlackText};
  &:hover {
    color: black;
  }
  &:hover > .icon,
  &:focus > .icon {
    fill: ${S.iconsColorHover};
    stroke: ${S.iconsColorHover};
    &.icon--dark {
      fill: black;
      stroke: black;
    }
  }
  &:visited {
    color: ${S.mainBlackText};
  }
  & > .icon {
    pointer-events: none;
    stroke: ${S.iconsColor};
    fill: ${S.iconsColor};
    transition: fill ${S.trFast}, stroke ${S.trFast};
    &.icon--dark {
      stroke: ${S.mainBlackText};
      fill: ${S.mainBlackText};
    }
  }
  & > :not(:first-child) {
    margin-left: 10px;
  }
  transition: color ${S.trFast};
`;

export const StyledHeaderNavRow = styled.div`
  position: absolute;
  top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: calc(100vh - 120px);
  width: 100vw;
  font-size: 24px;
  opacity: 0;
  transform: translateX(100%);
  transition: opacity 0s linear 500ms, transform ${S.trSlow},
    background 0s linear 500ms;
  &.opened {
    transform: translateX(-20px);
    opacity: 1;
    overflow: auto;
    background: #fff;
    transition: transform ${S.trSlow}, background 0s linear;
  }

  @media screen and (min-width: ${S.desktop}) {
    position: static;
    flex-direction: row;
    width: 100%;
    height: 100%;
    opacity: 1;
    transform: translateX(0);
    font-size: 16px;
    overflow: hidden;
    &.opened {
      background: transparent;
    }
  }
`;

export const StyledHeaderNavLinksWrapper = styled.div`
  flex-shrink: 0;
  @media screen and (min-width: ${S.desktop}) {
    height: 100%;
    overflow: hidden;
    width: calc(100% - 200px);
    padding-right: 10px;
  }
`;

export const StyledHeaderNavLinks = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 80px 0 20px;
  & > li {
    height: 50px;
  }
  @media screen and (min-width: ${S.desktop}) {
    margin: 0;
    height: 100%;
    justify-content: space-between;
    flex-direction: row;
    & > li {
      height: 100%;
      flex-shrink: 0;
      flex-grow: 1;
      &:not(:first-child) {
        margin-left: 20px;
      }
    }
    transition: transform ${S.trFast};
  }
`;

export const StyledHeaderLink = styled(NavLink)`
  position: relative;
  display: flex;
  height: 100%;
  width: fit-content;
  cursor: pointer;
  color: ${S.mainBlackText};
  &:hover,
  &:active {
    color: black;
  }
  & > span {
    margin: auto 0;
    &::first-letter {
      text-transform: uppercase;
    }
  }
  &.active {
    font-weight: 600;
  }
  &::after {
    position: absolute;
    bottom: 0;
    height: 4px;
    width: 100%;
    border-radius: 2px;
    background: ${S.accentGold};
    pointer-events: none;
    transform-origin: center;
    transform: scaleX(0);
    transition: transform ${S.trFast};
  }
  &.active::after {
    transform: scaleX(1);
  }
  @media (min-width: ${S.desktop}) {
    &::after {
      content: '';
    }
    &.active {
      font-weight: 400;
    }
  }
`;

export const StyledBurger = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 37px;
  height: 40px;
  cursor: pointer;
  & > span {
    transition: transform ${S.trFast};
  }
  &.opened > span {
    &:first-child {
      transform: translate(0, 10px) rotate(45deg);
    }
    &:last-child {
      transform: translate(0, -10px) rotate(-45deg);
    }
  }
  @media (min-width: ${S.desktop}) {
    display: none;
  }
`;

export const StyledBurgerStick = styled.span`
  width: 37px;
  height: 4px;
  border-radius: 2px;
  background: ${S.mainBlackText};
`;

export const StyledLogin = styled.a`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 80%;
  margin: 0 0 70px;
  cursor: pointer;
  background: ${S.mainBlackText};
  border-radius: 5px;
  color: white;
  & > * {
    pointer-events: none;
    fill: white;
    &:first-child {
      margin-right: 12px;
    }
  }
  @media (min-width: ${S.desktop}) {
    width: auto;
    height: 100%;
    margin: 0 0 0 50px;
    background: transparent;
    color: ${S.mainBlackText};
    & > svg {
      fill: ${S.mainBlackText};
    }
  }
`;
